import { extendTheme } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = extendTheme({
	colors: {
		greenish: {
			50: '#E6F7F6', // Very light background / card
			100: '#BFEFE9', // Lighter backgrounds, hover states
			200: '#99E7DC', // Soft borders / secondary buttons
			300: '#66DCCF', // Info highlights, badges
			400: '#33D1C2', // Buttons, icons hover
			500: '#158477', // Primary modal background, main buttons
			600: '#12665E', // Active states, borders
			700: '#0F534B', // Dark modal header/footer
			800: '#0C3F38', // Floating action button shadow, overlay
			900: '#07221C', // Text shadow, deepest accents
		},
		brand: {
			50: '#FAF7E7',
			100: '#F5ECCB',
			200: '#EDD199',
			300: '#E5B668',
			400: '#D99A36',
			500: '#B79045',
			600: '#B79045',
			700: '#755A24',
			800: '#544013',
			900: '#332602',
		},
		brandScheme: {
			100: '#F5ECCB',
			200: '#E5B668',
			300: '#E5B668',
			400: '#D99A36',
			500: '#B79045',
			600: '#B79045',
			700: '#755A24',
			800: '#544013',
			900: '#332602',
		},
		brandTabs: {
			100: '#F5ECCB',
			200: '#EDD199',
			300: '#EDD199',
			400: '#EDD199',
			500: '#EDD199',
			600: '#B79045',
			700: '#755A24',
			800: '#544013',
			900: '#332602',
		},
		softGray: {
			50: '#E7E7E7',
			100: '#eeeeef',
			200: '#BEBEBE',
			300: '#969696',
			400: '#F5F5F5',
			500: '#C4C4C4',
			600: '#D9D9D9',
			700: '#F6F6F6',
			800: '#F2F2F2',
		},
		secondaryGray: {
			100: '#E0E5F2',
			200: '#E1E9F8',
			300: '#F4F7FE',
			400: '#E9EDF7',
			500: '#8F9BBA',
			600: '#A3AED0',
			700: '#707EAE',
			800: '#707EAE',
			900: '#1B2559',
		},
		red: {
			100: '#FEEFEE',
			300: '#eb7b74',
			500: '#EE5D50',
			600: '#E31A1A',
		},
		blue: {
			50: '#EFF4FB',
			400: '#3B82F6',
			500: '#3965FF',
		},
		orange: {
			100: '#FFF6DA',
			400: '#fde04ce8',
			500: '#FFB547',
		},
		green: {
			100: '#E6FAF5',
			400: '#10B981',
			500: '#01B574',
			600: '#32BD00',
			700: '#32BD00',
		},
		navy: {
			50: '#d0dcfb',
			100: '#aac0fe',
			200: '#a3b9f8',
			300: '#728fea',
			400: '#3652ba',
			500: '#1b3bbb',
			600: '#24388a',
			700: '#1B254B',
			800: '#111c44',
			900: '#0b1437',
		},
		gray: {
			100: '#FAFCFE',
			200: '#E2E8F0',
			300: '#CBD5E0',
			400: '#A0AEC0',
			500: '#718096',
			600: '#4A5568',
			700: '#2D3748',
			800: '#1A202C',
			900: '#171923',
		},
	},

	styles: {
		global: (props) => ({
			'*:focus': {
				outline: 'none !important',
				boxShadow: 'none !important',
			},
			body: {
				overflowX: 'hidden',
				bg: mode('secondaryGray.300', 'navy.800')(props),
				fontFamily: 'DM Sans, sans-serif',
				letterSpacing: '-0.5px',
			},
			input: {
				color: 'gray.700',
			},
			html: {
				fontFamily: 'DM Sans, sans-serif',
			},
		}),
	},
});
